import { getForcedCurrencyScale } from "helpers/formatters/numbers"

export function getCurrencyScaleForValues(values: readonly unknown[]): string {
  const maxMagnitude = values.reduce<number>(
    (largestMagnitude, value) => typeof value === "number" && Number.isFinite(value)
      ? Math.max(largestMagnitude, Math.abs(value))
      : largestMagnitude,
    0,
  )
  return getForcedCurrencyScale(maxMagnitude)
}
